import React from 'react'
import Laravel from '../components/Laravel'
import PhpdevlopmentBanner from '../components/PhpdevlopmentBanner'
import CodeIgniterTechnology from '../components/CodeIgniterTechnology'
import Cakephptechnology from '../components/Cakephptechnology'
import SymfonyTechnology from '../components/SymfonyTechnology'

const Phpdevlopmentpage = () => {
  return (
    <>
        <PhpdevlopmentBanner />
        <Laravel />
        <CodeIgniterTechnology />
        <Cakephptechnology />
        <SymfonyTechnology />
    </>
  )
}

export default Phpdevlopmentpage
